export default __webpack_public_path__ + "static/media/aiColorActive.svg.bccd5e37.svg";